import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let DiscountAdmissionsZoneController = {

    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/discount-admissions-zone/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    list: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/discount-admissions-zone/list`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    listDiscountZone: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/discount-admissions-zone/list-discount-zone`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/discount-admissions-zone/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    detail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/discount-admissions-zone/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    delete: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/discount-admissions-zone/delete/${id}`,
            method: 'GET'
        }, callback)
    }
}

export default DiscountAdmissionsZoneController
